(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/jackpots/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/jackpots/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.jackpot = svs.numbergames.jackpot || {};

 })(window);